// Simple notification sound using Web Audio API
let audioContext: AudioContext | null = null;

const SOUND_ENABLED_KEY = 'pixie-chat-sound-enabled';

function getAudioContext(): AudioContext {
  if (!audioContext) {
    audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
  }
  return audioContext;
}

export function isSoundEnabled(): boolean {
  const stored = localStorage.getItem(SOUND_ENABLED_KEY);
  return stored === null ? true : stored === 'true';
}

export function setSoundEnabled(enabled: boolean): void {
  localStorage.setItem(SOUND_ENABLED_KEY, String(enabled));
}

export function playNotificationSound() {
  if (!isSoundEnabled()) return;

  try {
    const ctx = getAudioContext();
    
    // Resume context if suspended (browser autoplay policy)
    if (ctx.state === 'suspended') {
      ctx.resume();
    }

    const now = ctx.currentTime;
    
    // Create oscillator for a soft, pleasant chime
    const oscillator = ctx.createOscillator();
    const gainNode = ctx.createGain();
    
    oscillator.connect(gainNode);
    gainNode.connect(ctx.destination);
    
    // Soft sine wave for a gentle notification
    oscillator.type = 'sine';
    oscillator.frequency.setValueAtTime(880, now); // A5 note
    oscillator.frequency.exponentialRampToValueAtTime(1320, now + 0.1); // E6 note
    
    // Fade in and out for a smooth sound
    gainNode.gain.setValueAtTime(0, now);
    gainNode.gain.linearRampToValueAtTime(0.15, now + 0.02);
    gainNode.gain.exponentialRampToValueAtTime(0.01, now + 0.25);
    
    oscillator.start(now);
    oscillator.stop(now + 0.25);
  } catch (error) {
    // Silently fail if audio isn't available
    console.log('Notification sound unavailable:', error);
  }
}
